import Repository from './Repository';

const SEND_INVITATION_EMAIL = '/sendInvitationEmail';

export default {
  sendInvitationEmail(payload) {
    return Repository.post(SEND_INVITATION_EMAIL, payload);
  },
}
